import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';

const RefreshStateButton = () => {
  const queryClient = useQueryClient();
  
  const handleRefresh = () => {
    // Hard refresh approach - most reliable
    window.location.reload();
  };
  
  return (
    <button
      onClick={handleRefresh}
      className="fixed bottom-4 right-4 bg-accent-teal text-white p-2 rounded-full shadow-lg z-50 hover:bg-opacity-90"
      title="Refresh page if content isn't loading"
    >
      <RefreshCw size={20} />
    </button>
  );
};

export default RefreshStateButton; 